import { WaitingOn, type EnumDef } from '@clawhire/shared';
import { PropertiesPanel, type PropertyField } from '@/components/data/PropertiesPanel';
import type { SubmissionDetail, SubmissionPatch } from '@/pages/submissions/types';

export interface TrackingBlockProps {
  submission: SubmissionDetail;
  canEdit: boolean;
  onPatch: (patch: SubmissionPatch) => Promise<unknown>;
}

/** Waiting on, next step, follow-up, feedback due (read-only), sent on, right to represent. */
export function TrackingBlock({ submission: s, canEdit, onPatch }: TrackingBlockProps) {
  const fields: PropertyField[] = [
    {
      key: 'waitingOn',
      label: 'Waiting on',
      type: 'enum',
      def: WaitingOn as unknown as EnumDef<string>,
      value: s.waitingOn,
      allowEmpty: true,
      help: 'Who has to act next; drives the chase list together with feedback due.',
    },
    {
      key: 'nextStep',
      label: 'Next step',
      type: 'text',
      value: s.nextStep,
      placeholder: 'e.g. client feedback on the profile',
    },
    { key: 'followUpOn', label: 'Follow-up on', type: 'date', value: s.followUpOn },
    {
      key: 'feedbackDue',
      label: 'Feedback due',
      type: 'date',
      value: s.feedbackDue,
      editable: false,
      help: 'Set automatically from "sent on" when the submission is moved to Submitted.',
    },
    { key: 'sentOn', label: 'Sent on', type: 'date', value: s.sentOn },
    { key: 'rtrReceived', label: 'Right to represent', type: 'boolean', value: s.rtrReceived },
    { key: 'rtrDate', label: 'RTR date', type: 'date', value: s.rtrDate },
  ];
  return (
    <PropertiesPanel
      fields={fields}
      onSave={(patch) => onPatch(patch as SubmissionPatch)}
      readOnly={!canEdit}
    />
  );
}
